import { Tabs } from "materials/tabs/menus/model"
// import { More } from "../more/model"
import { Pagination } from "materials/pagination/menus/model"
export class emptyLayout {
  constructor(difference) {
    this.createBlockTimes = 0
    this.styleName = "1"
    this.innerElement = "emptyLayoutComponent"
    this.width = 800
    this.height = 480
    this.top = 10
    this.left = 10
    this.moduleId = ""
    this.appId = ""
    this.isCache = true
    this.isShowTabs = true
    this.isShowPagination = true
    this.isShowTitle = true
    this.isShowMoreBtn = true
    this.activeIndex = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.boxShadowColor = "rgba(96,100,106,0)"
    this.boxShadowH = 0
    this.boxShadowV = 0
    this.boxShadowBlur = 0
    this.boxShadowSpread = 0
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = ""
    this.opacity = 100
    this.noCacheComponent = false
    this.updateTimer = 100
    this.reverseGetColsUid = false
    this.titleOptionsWidth = 80
    this.titleOptionsHeight = 80
    this.inBodyL = true
    this.inBodyR = true
    this.isDrawerModeL = false
    this.isDrawerModeR = false
    this.titleOptions = [
      {
        type: "top",
        width: 800,
        height: 80,
        isShow: true,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 3,
            options: new Tabs({})
          }
          // {
          //   innerElement: "cxMore",
          //   isActive: false,
          //   isShow: true,
          //   type: "more",
          //   elementInLayoutId: 0,
          //   options: new More({
          //     left: 662,
          //     top: 32
          //   })
          // }
        ]
      },
      {
        type: "bottom",
        width: 800,
        height: 80,
        isShow: true,
        elementOptions: [
          {
            innerElement: "cxPagination",
            isActive: false,
            isShow: true,
            type: "pagination",
            elementInLayoutId: 0,
            options: new Pagination({})
          }
        ]
      },
      {
        type: "left",
        isShow: false,
        width: 80,
        height: 400,
        elementOptions: []
      },
      {
        type: "right",
        isShow: false,
        width: 80,
        height: 400,
        elementOptions: []
      }
    ]
    // this.animateSets = {
    //   animateType: 0,
    //   animateDirection: "无",
    //   animateDuration: 1.5,
    //   animateDelay: 0,
    //   hasDirection: false,
    //   animateTriggerNumType: "单次触发",
    //   animateClass: "",
    //   executionAnimateClass: ""
    // }
    this.rows = []
    // this.rows = [
    //   {
    //     height: "100%",
    //     alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
    //     cols: [
    //       //width加起来不能大于12
    //       {
    //         uid: "emptyLayoutComponentRootBox",
    //         alignSelf: "stretch",
    //         width: "100%",
    //         component: null,
    //         elementOptions: [],
    //         componentBoxOptions: {
    //           showAutoLayout: false,
    //           direction: "vertical", // vertical  horizon
    //           alignPositionH: "left", // left center right
    //           alignPositionV: "top", // top middle bottom
    //           marginBottom: 0, //自动布局时 组件之间的间距
    //           padding: 0,
    //           paddingTop: 0,
    //           paddingBottom: 0,
    //           paddingLeft: 0,
    //           paddingRight: 0,
    //           borderStyle: "dashed", // solid, dashed, dotted
    //           borderColor: "rgba(96,100,106,1)",
    //           borderWidth: 1,
    //           clipSize: "cover",
    //           repeatType: "no-repeat",
    //           alignType: "center center",
    //           imgSrc: "",
    //           opacity: 100,
    //           animateSets: {
    //             animateType: 0,
    //             animateDirection: "无",
    //             animateDuration: 1.5,
    //             animateDelay: 0,
    //             hasDirection: false,
    //             animateTriggerNumType: "单次触发",
    //             animateClass: "",
    //             executionAnimateClass: ""
    //           }
    //         }
    //       }
    //     ]
    //   }
    // ]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
